import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import zIndex from '@material-ui/core/styles/zIndex';
import LocationIcon from '../../assets/image/location.png';
import InstagramIcon from '../../assets/image/instagram.png';
import PhoneIcon from '../../assets/image/phone.png';
import ShopIcon from '../../assets/image/shop.png';
import CloseIcon from '../../assets/image/close.png';
import CheckIcon from '../../assets/image/f-check.png';
import EmptyIcon from '../../assets/image/specular.png'
import { seller } from '../../config/api';
import GAEvent from '../../utils/googleAnalytics';
import numeral from 'numeral';
import { V2_BACKGROUND_COLOR, V2_POINT_COLOR } from '../../config/color';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 999,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 20px',
    
  },
  content: {
    inset: 0,
    width: 600,
    position: 'relative',
    borderRadius: '24px',
    padding: '40px 0 20px',
    left: 0,
    top: 20
  }
};

const ModalContainer = styled.div`
  width: 100%;
`

const CloseButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 48px;
  position: absolute;
  right: 20px;
  top: 20px;
  background-color: white;
  border: none;
  outline: none;
  box-shadow: 0 0.5rem 1.2rem rgba(0, 0, 0, 0.1);
  padding: 10px;
  cursor: pointer;
`

const NoticeTextContainer = styled.div`
  position: absolute;
  left: 50px;
  top: 40px;
`

const ModalContent = styled.div`
  width: 100%;
  margin-top: 60px;
  height: 400px;
  display: flex;
  flex-direction: column;
  /* justify-content: center;
  align-items: center; */
  @media (max-width: 768px) {
    margin-top: 50px;
  }
`

const RankingContainer = styled.div`
  width: 470px;
`

const RankingTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 0 20px;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`


const AlignListing = styled.p`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    &:is(:nth-child(2)) {
      flex: 1.2
    }
    &:is(:nth-child(3)) {
      flex: 1
    }
    &:is(:nth-child(3)) {
      flex: 1.5
    }
    &:is(:nth-child(4)) {
      flex: 0.3
    }
  }
`

const RankingList = styled.div`
  width: 100%;
  margin: 14px 0 24px;
  background-color: white;
  border-radius: 15px;
  padding: 0 20px;
`

const RankingListItem = styled.div`
  width: 100%;
  outline: none;
  background-color: white;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  border-bottom: 1px solid #E5E5E5;
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 12px;
  }

  &:is(:last-child) {
    border-bottom: 0px;
  }
`

export default ({modalIsOpen, modalIsClose, sellerList}) => {

  let rank = 1;
  for (let i = 0; i < sellerList?.length; i++) {
    // increase rank only if current score less than previous
    if (i > 0 && sellerList[i].Seller.score < sellerList[i - 1].Seller.score) {
      rank++;
    }
      sellerList[i].rank = rank;
  }

  // let rank = 1;
  let watchSellerList = sellerList?.sort((a, b) => b?.Seller?.score - a?.Seller?.score);


  watchSellerList = watchSellerList?.filter( o => o.price >= 0)

  const __goSellerWebsite = async (o) => {
    GAEvent('Link', '웹사이트', `${o?.Seller?.name} ${o?.Seller?.website}`);
    window.open(o?.Seller?.website, '_blank');

    try {
      await seller.sellerItemViewCount(o?.sellerId);
    } catch(e) {
      console.log(e);
    }
  }

  const __goSellerItemLink = async (o) => {
    GAEvent('Link', '아이템 링크', `${o?.sellerId} ${o?.url}`);
    window.open(o?.url, '_blank');

    try {
      await seller.sellerItemViewCount(o?.sellerId);
    } catch(e) {
      console.log(e)
    }
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        style={customStyles}
        onRequestClose={() => modalIsClose()}
      >
        <ModalContainer>
          <CloseButton onClick={() => modalIsClose()}>
            <img style={{width: '100%'}} src={CloseIcon} />
          </CloseButton>
          <ModalContent>
            {watchSellerList?.length !== 0 ? (
              <>
                <RankingTitle>
                  <AlignListing>상점</AlignListing>
                  {/* <AlignListing>순위</AlignListing> */}
                  <AlignListing>위치</AlignListing>
                  <AlignListing>가격</AlignListing>
                  <AlignListing>전화</AlignListing>
                </RankingTitle>
                <RankingList>
                  {watchSellerList?.map((o, i) => {
                    return (
                      <RankingListItem>
                        <AlignListing style={{cursor: 'pointer'}} onClick={() => __goSellerWebsite(o)} >
                          <p style={{color: '#11142D', fontWeight: 600, marginRight: 4, textDecoration: 'underline'}}>{o?.Seller?.name}</p>
                          {/* <p style={{width: 14}}>
                            <img style={{width: '100%'}} src={LocationIcon}/>
                          </p> */}
                        </AlignListing>
                        {/* <AlignListing style={{color: '#808191'}}># {i + 1}</AlignListing> */}
                        <AlignListing>{o?.Seller?.si} {o?.Seller?.gu}</AlignListing>
                        <AlignListing style={{cursor: 'pointer'}} onClick={() => __goSellerItemLink(o)} >
                          <p style={{color: '#11142D', fontWeight: 600, marginRight: 4, textDecoration: 'underline'}}>
                            {o?.price > 0 ? `${numeral(o?.price).format('0,0')}원` : '가격문의'}
                          </p>
                          {/* <p style={{width: 14}}>
                            <img style={{width: '100%'}} src={LocationIcon}/>
                          </p> */}
                        </AlignListing>
                        <AlignListing>
                          <a style={{width: 16}} href={`tel:${o?.Seller?.phoneNumber}`}>
                            <img style={{width: '100%'}} src={PhoneIcon} />
                          </a>
                        </AlignListing>
                      </RankingListItem>
                    )
                  })}
                </RankingList>
              </>
            ) : (
              <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 60}}>
                <div style={{marginBottom: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                  <p style={{fontWeight: 900, fontSize: 24, lineHeight: '24px', marginBottom: 20}}>
                    이런!
                  </p>
                  <p style={{fontWeight: 600, fontSize: 16, lineHeight: '24px'}}>
                    현재 해당 물품을 보유한 상점이 없습니다.
                  </p>
                  <p style={{fontWeight: 600, fontSize: 16, lineHeight: '24px'}}>
                    트레져러는 매일 매일 조금씩 자라나고 있습니다.
                  </p>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                  <p style={{width: 100, marginBottom: 30}}>
                    <img src={EmptyIcon} style={{width: '100%'}} />
                  </p>
                  <p style={{fontWeight: 900, fontSize: 16, lineHeight: '16px'}}>
                    (쩜쩜쩜... 죄송해요)
                  </p>
                </div>
              </div>
            )}
          </ModalContent>
        </ModalContainer>
      </Modal>
    </>
  )
}